export class AppkitError<Code extends string = ''> extends Error {
  code: Code = '' as Code;
  message = ''

  constructor() {
    super('')
  }

  toString() {
    return JSON.stringify(this)
  }
}
